// 日本語テーブル（機械翻訳・未校正 — ruling G4）。
// The Japanese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  loading: "読み込み中…",
  building: "生成中…",
  layingOut: "レイアウト中…",
  makingFile: "ファイルを作成中…",
  timedOut: "生成が10秒で終わらず再開しました — 文字を減らすか別のフォントをお試しください",
  loadFailed: "読み込めません — ページを再読み込みしてください",
  triangles: (n) => `三角形 ${n.toLocaleString('en-US')} 個`,
  loading3d: "3Dビューを読み込み中…",
  load3dFailed: "3Dビューを開けませんでした — もう一度お試しください",
  fontLoading: (family, got, total) => (total > 0 ? `${family} を読み込み中 ${got} / ${total} MB` : `${family} を読み込み中 ${got} MB`),
  fontLinkNote: (family) => `${family} を読み込めません — 接続を確認 · 現在のフォントを使用`,
  more: (n) => `他 ${n} 件`,
  placeholder: {
    name: "例: Big",
    phone: "0812345678",
  },
  emptyEl: "（なし）",
  addTitle: "テキストまたはアイコンを追加",
  resetWarning: "カスタムレイアウトがリセットされ、追加したパーツは削除されます（↶ で元に戻す）",
  hint: {
    touch: "タグ上のどこでもドラッグして選択パーツを移動できます — 文字の上で押す必要はありません",
    mouse: "マウスでパーツをドラッグ、または矢印キー（Shift = 1 mm刻み）",
  },
  ariaPreview: {
    front: "2Dプレビュー",
    back: "2Dプレビュー、裏",
  },
  iconSize: "アイコンサイズ",
  textSize: "文字サイズ",
  roleLabel: {
    name: "名前",
    phone: "電話",
    text: "テキスト",
    icon: "アイコン",
  },
  fieldLabel: {
    name: "ペットの名前",
    phone: "電話番号",
    text: "テキスト",
    icon: "アイコン",
  },
  face: {
    back: "（裏）",
  },
  copied: "リンクをコピーしました — チャットに貼り付けられます",
  copyManual: "自動コピーできませんでした — 上のリンクを長押ししてコピーしてください",
  shape: {
    circle: "丸",
    bone: "骨",
    heart: "ハート",
    paw: "肉球",
    cat: "猫の顔",
  },
  template: {
    name: "名前のみ",
    "name-phone": "名前 + 電話番号",
    "name-front-phone-back": "表に名前、裏に電話番号",
    "icon-name": "アイコン + 名前",
    "icon-name-phone-back": "アイコン + 名前、裏に電話番号",
  },
  icon: {
    paw: "肉球",
    heart: "ハート",
    bone: "骨",
    star: "星",
    fish: "魚",
    cat: "猫",
    dog: "犬",
    phone: "電話",
  },
  preset: {
    dog: "犬",
    cat: "猫",
    paw: "肉球",
    heart: "ハート",
  },
  engravedNote: "彫刻の文字はタグと同色です — 2色の文字にするには「盛り上げ」を選んでください",
  singleColour: "1色 — どのプリンターでもプリントできます",
  threeMf: (tagName, textName, z, n) => `3MF: タグ = フィラメント1（${tagName}）、文字 = フィラメント2（${textName}）· 単ノズル: Z = ${z} mm で色替え（レイヤー ${n} @0.2 mm）— 穴の縁も文字の色でプリントされます`,
  title: "ペット迷子札",
  lineNote: "ファイルのダウンロードは通常のブラウザで開いて行ってください — 作ったデザインも一緒に持ち越せます",
  lineOpen: "ブラウザで開く",
  retryNote: "読み込めませんでした — タップして再読み込み",
  faceBtn: {
    front: "表",
    back: "裏",
  },
  ariaFace: {
    front: "表側",
    back: "裏側",
  },
  faceNote: "裏から見たところ — 文字は普通に読めます · 裏面は常に 0.6 mm の彫刻です",
  gTag: "タグのスタイル",
  presetsLabel: "プリセットから始める",
  ariaPresets: "プリセット",
  templatesLabel: "レイアウト",
  ariaTemplates: "レイアウト",
  gShape: "形",
  shapesLabel: "タグの形",
  ariaShapes: "タグの形",
  sizeLabel: "タグのサイズ",
  sizeHint: "目安: 10バーツ硬貨 = 26 mm",
  sizeRanges: "猫・小型犬 25–30 · 中型犬 30–38 · 大型犬 38 mm 以上",
  holeLabel: "首輪リング用の穴",
  holes: {
    inside: "内側に穴",
    tab: "上にタブ",
  },
  thickLabel: "厚さ",
  gColour: "色",
  modeLabel: "文字の様式",
  modes: {
    raised: "盛り上げ",
    engraved: "彫刻",
  },
  colourLabel: {
    tag: "タグの色",
    text: "文字の色",
  },
  gAdv: "位置を自分で調整",
  advanced: "自分で調整",
  backToSimple: "← かんたんモードへ戻る",
  resetTemplate: "テンプレートに戻す",
  cancel: "キャンセル",
  confirmReset: "OK、リセット",
  ariaChips: "タグ上のパーツ",
  ariaAdd: "パーツを追加",
  addText: "＋ 文字",
  ariaSheet: "選んだパーツを調整",
  sheetEmpty: "調整するパーツは、タグ上のパーツか上のチップをタップして選んでください",
  emPre: "サイズ: ",
  mmPost: " mm",
  nudgePre: "0.25 mm 移動 · 回転 ",
  nudgePost: "°（タップ = 15°、長押し = 1°ずつ）",
  ariaNudge: {
    left: "左へ移動",
    up: "上へ移動",
    down: "下へ移動",
    right: "右へ移動",
  },
  ariaRot: {
    ccw: "反時計回りに回転",
    cw: "時計回りに回転",
  },
  deletePiece: "このパーツを削除",
  aboutH2: "犬と猫の首輪タグ — 名前 + 電話番号、2色の3Dプリント",
  aboutP: "犬と猫の首輪タグをデザインしましょう。ペットの名前と飼い主の電話番号を入れ、形・アイコン・2色（タグと文字）を市販されているフィラメントから選び、マルチカラー用に 3MF、1色用に STL を無料でダウンロードできます。ブラウザで使え、インストールは不要です。",
  printLi1: "PLA または PETG で 0.2 mm 積層でプリント",
  printLi2: "AMS/CFS 機で2色プリント — 3MFにはタグ=フィラメント1、盛り上げ文字=フィラメント2が組み込み済み。実際のフィラメントの色はスライサーで選んでください",
  printLi3: "単ノズル機の場合: 文字の色の下に表示された Z 高さで一時停止し、フィラメントを交換してください",
  footerNote: "すべてのタグはウォータータイト検査済み — 穴とその周囲の補強リングはそのまま使えます",
  ariaDownloads: "ダウンロード",
  dlstl: "STLを保存",
  ariaShareUrl: "このデザインのリンク",
  ariaClose: "閉じる",
  // a link that cannot open (src/doc.js decodeFragment's codes, worded by src/ui/share-ui.js)
  link: {
    bad: "このリンクは使えません — 新しいリンクをもらってください",
    newer: "このリンクは新しいバージョンのものです",
  },
  // What the worker reports, in words (ruling R9: the worker speaks codes, src/worded.js says them)
  worker: {
    fontLoad: "フォントを読み込めませんでした — もう一度お試しください",
    face: {
      front: "表面",
      back: "裏面",
    },
    tooDetailed: (face) => `${face}の文字が細かすぎます — 文字を減らすかフォントを変えてください`,
    missingChars: (label, chars) => `${label}: このフォントには ${chars} がありません`,
    badChar: (label, point) => `${label}: 使えない文字があります（${point}）— 削除して入力し直してください`,
    leadingMark: (label) => `${label}が浮いた母音・声調記号で始まっています — 前に子音を入れてください`,
    empty: "ペットの名前を入力してください",   // one line in the bar at 360 (acceptance 7: the Japanese bar no taller than the Thai one)
    tooMany: (max) => `片面に置けるのは ${max} 個までです`,
    quoteText: (text) => `「${text}」`,
    quoteIcon: (name) => `${name}のアイコン`,
    outside: (what) => `${what}がタグの縁からはみ出しています`,
    onHole: (what) => `${what}がリング穴に重なっています`,
    overlap: (what) => `${what}が他の要素に近すぎるか重なっています`,
    tooThin: (what) => `${what}は小さすぎてきれいに印刷できません`,
    tooThinBack: (what, factor) => `${what}は裏面には小さすぎます（裏面は表面の約 ${factor} 倍の大きさが必要です）`,
    tooThinBackFit: (what) => `${what}は裏面に彫るには小さすぎます`,
    tooThinTag: (mm) => `裏面に彫るにはタグが薄すぎます — 厚さを ${mm} mm 以上にしてください`,
    holeWall: "リング穴の周りの縁が薄すぎます — タグを大きくするか穴の形を変えてください",
    noFit: {
      front: "このサイズのタグには文字が長すぎます",
      back: "このサイズのタグには裏面の文字が長すぎます",
    },
    wayOut: (why, way) => `${why} — ${way}`,
    way: {
      plain: "タグを大きくするか文字を短くしてください",
      phone: "タグを大きくする、文字を短くする、または電話番号を裏面に移してください",
    },
    phoneToBack: "電話番号を裏面に移す",
  },
  // the name on this page's share card (R69): the page opens with no name, as it always has — the card shows one, in Latin (no bundled family has kana or Han)
  cardName: "Mochi",
};
export default S;
